import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class Scale extends DesigntimeComponent {
    static staticName = "Scale";
    static staticId = "scale";
    runtimeValue = null;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            header: { value: "Header" },
            infoLeft: { value: "Name a reason" },
            infoRight: { value: "Score" },
            placeholderText: { value: "e.g. enjoyable, exciting" },
            scoreLow: { value: "small" },
            scoreHigh: { value: "big" },
            removeText: { value: "remove" },
            addToListText: { value: "Add an advantage (max. 3)" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var $view = $("<div></div>");

        var $textbox = $("<div class='sid-question-text'></div>");
        $textbox.append("<h3>" + componentHelpers.mdToHtml(this.values.header.value) + "</h3>")
        $view.append($textbox);

        var $listHeaders = $("<div class='sid-scale-header-container sid-clearfix'></div>");
        $listHeaders.append($(`<div class='sid-scale-header sid-scale-header-left sid-arrow'>${this.values.infoLeft.value}</div>`));
        $listHeaders.append($(`<div class='sid-scale-header sid-scale-header-right sid-arrow'>${this.values.infoRight.value}</div>`));

        $view.append($listHeaders);

        var $box1 = this.getAnswerContainer("answer_1", this.values.placeholderText.value, this.values.scoreLow.value, this.values.scoreHigh.value, this.values.removeText.value);
        $box1.find(".sid-remove-answer-link").hide();
        $view.append($box1);

        var $box2 = this.getAnswerContainer("answer_2", this.values.placeholderText.value, this.values.scoreLow.value, this.values.scoreHigh.value, this.values.removeText.value);
        $box2.hide();
        $view.append($box2);

        var $box3 = this.getAnswerContainer("answer_3", this.values.placeholderText.value, this.values.scoreLow.value, this.values.scoreHigh.value, this.values.removeText.value);
        $box3.hide();
        $view.append($box3);

        var $addItemContainer = $("<div class='sid-scale-add-argument'></div>")
        var $addItemButton = $("<button class='sid-add-item-button'></button>")
        $addItemButton.append(this.getSvg());
        $addItemButton.append($(`<span>${this.values.addToListText.value}</span>`));

        $addItemButton.click(function () {
            var $answer2 = componentHelpers.getRtFrame(this.id).find(".answer_2");
            if (!this.isVisible($answer2)) {
                $answer2.show();
                return;
            }
            var $answer3 = componentHelpers.getRtFrame(this.id).find(".answer_3");
            if (!this.isVisible($answer3)) {
                $answer3.show();
                componentHelpers.getRtFrame(this.id).find(".sid-scale-add-argument").hide();
                return;
            }
        }.bind(this));

        $addItemContainer.append($addItemButton);
        $view.append($addItemContainer);

        return $view;
    }

    isVisible($element) {
        return (
            ($element.css('display') !== 'none') && ($element.css('visibility') !== 'hidden'));
    }

    getSvg() {
        return $(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path class="siBmiPlusSquare" d="M 400 32 H 48 C 21.5 32 0 53.5 0 80 v 352 c 0 26.5 21.5 48 48 48 h 352 c 26.5 0 48 -21.5 48 -48 V 80 c 0 -26.5 -21.5 -48 -48 -48 Z m -32 252 c 0 6.6 -5.4 12 -12 12 h -92 v 92 c 0 6.6 -5.4 12 -12 12 h -56 c -6.6 0 -12 -5.4 -12 -12 v -92 H 92 c -6.6 0 -12 -5.4 -12 -12 v -56 c 0 -6.6 5.4 -12 12 -12 h 92 v -92 c 0 -6.6 5.4 -12 12 -12 h 56 c 6.6 0 12 5.4 12 12 v 92 h 92 c 6.6 0 12 5.4 12 12 v 56 Z" /></svg>`);
    }

    getAnswerContainer(answerId, placeholderText, scoreLow, scoreHigh, removeText) {
        var $answerContainer = $(`<div class='sid-question-answer-container sid-clearfix ${answerId}'></div>`);
        var $answerForm = $(`<div class='sid-clearfix answerForm'></div>`);
        var $textInputBox = $(`<div class='sid-scale-field sid-scale-left textInput'></div>`);
        $textInputBox.append($(`<input type='text' placeholder='${placeholderText}'></input>`));
        $textInputBox.find("input").change(function () {
            this.openNextButton();
        }.bind(this));

        $answerForm.append($textInputBox);
        var $scoreInputBox = $(`<div class='sid-scale-right scoreInput'></div>`);
        $scoreInputBox.append(this.getScoreDropDown(scoreLow, scoreHigh));
        $answerForm.append($scoreInputBox);
        $answerContainer.append($answerForm);

        var $removeContainer = $("<div class='sid-remove-answer-box'></div>");
        var $removeLink = $(`<a class='sid-remove-answer-link'>${removeText}<a>`);
        $removeLink.click(function (e) {
            $(e.currentTarget).closest('.sid-question-answer-container').hide();
            componentHelpers.getRtFrame(this.id).find(".sid-scale-add-argument").show();
        });

        $removeContainer.append($removeLink);
        $answerContainer.append($removeContainer);

        return $answerContainer;
    }

    getScoreDropDown(scoreLow, scoreHigh) {
        var $select = $("<select class='sid-scale-select'></select>");
        $select.append($("<option disabled='disabled' selected='selected'>-</option>"));
        $select.append($(`<option value=1>1 (${scoreLow})</option>`));
        $select.append($(`<option value=2>2</option>`));
        $select.append($(`<option value=3>3</option>`));
        $select.append($(`<option value=4>4</option>`));
        $select.append($(`<option value=5>5 (${scoreHigh})</option>`));

        $select.change(function () {
            this.openNextButton();
        }.bind(this));

        return $select;
    }

    openNextButton() {
        var score = componentHelpers.getRtFrame(this.id).find(".sid-scale-select").val();
        var text = componentHelpers.getRtFrame(this.id).find(".textInput input").val();
        if (score && text) {
            this.enableNextButton();
        }
    }

    getOutput() {
        var $frame1 = componentHelpers.getRtFrame(this.id).find(".answer_1");
        var $frame2 = componentHelpers.getRtFrame(this.id).find(".answer_2");
        var $frame3 = componentHelpers.getRtFrame(this.id).find(".answer_3");

        var question1answered = $frame1.is(":visible");
        var text1 = $frame1.find(".textInput input").val();
        var score1 = parseInt($frame1.find(".sid-scale-select").val());

        var question2answered = $frame2.is(":visible");
        var text2 = $frame2.find(".textInput input").val();
        var score2 = parseInt($frame2.find(".sid-scale-select").val());

        var question3answered = $frame3.is(":visible");
        var text3 = $frame3.find(".textInput input").val();
        var score3 = parseInt($frame3.find(".sid-scale-select").val());

        var total = score1;
        var count = 1;
        if (question2answered) {
            total += score2;
            count = 2;
        }
        if (question3answered) {
            total += score3;
            count = 3;
        }

        var average = total / count;

        var res = {
            question1answered: question1answered,
            text1: text1,
            score1: score1,

            question2answered: question2answered,
            text2: text2,
            score2: score2,

            question3answered: question3answered,
            text3: text3,
            score3: score3,

            average: average
        };

        return res;
    }

    output = [
        { name: "question1answered", type: "bool" },
        { name: "text1", type: "text" },
        { name: "score1", type: "number" },
        { name: "question2answered", type: "bool" },
        { name: "text2", type: "text" },
        { name: "score2", type: "number" },
        { name: "question3answered", type: "bool" },
        { name: "text3", type: "text" },
        { name: "score3", type: "number" },
        { name: "average", type: "number" }
    ];
}

export { Scale }
